import CloseIcon from '@mui/icons-material/Close';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router';

import { RowPreviewSuppressedContext } from '~/components/rowPreview/useTableRowPreview';
import { TaskDetailView } from '~/components/tasks/detail/TaskDetailView';

export const taskPath = (taskId: string) => `/tasks/${taskId}`;

export function TaskDetailDialog({
  taskId,
  onClose,
}: {
  taskId: string | null;
  onClose: () => void;
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [rendered, setRendered] = useState(taskId);
  if (taskId && taskId !== rendered) {
    setRendered(taskId);
  }

  return (
    <Dialog
      open={taskId !== null}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      fullScreen={fullScreen}
      aria-labelledby="task-detail-dialog-title"
      TransitionProps={{ onExited: () => setRendered(null) }}
      sx={
        fullScreen
          ? undefined
          : {
              '& > .MuiDialog-container > .MuiPaper-root': {
                height: 'calc(100vh - 64px)',
                width: 'calc(100vw - 96px)',
                maxWidth: 1440,
              },
            }
      }
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 1,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography id="task-detail-dialog-title" variant="h6" sx={{ flex: 1 }}>
          Task
        </Typography>
        {rendered ? (
          <Tooltip title="Open full page">
            <IconButton
              component={Link}
              to={taskPath(rendered)}
              size="small"
              aria-label="Open full page"
            >
              <OpenInFullIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : null}
        <Tooltip title="Close">
          <IconButton onClick={onClose} size="small" aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
        <RowPreviewSuppressedContext.Provider value>
          {rendered ? <TaskDetailView key={rendered} taskId={rendered} variant="dialog" /> : null}
        </RowPreviewSuppressedContext.Provider>
      </DialogContent>
    </Dialog>
  );
}
